function trackUnstructEvents(schema, data) {
  if (window.ahana) {
    window.ahana('trackSelfDescribingEvent', {
      event: {
        schema,
        data,
      },
    })
  }
}

function trackStructEvent(event) {
  if (window.ahana) {
    const {
      category, action, label, property, value,
    } = event
    window.ahana('trackStructEvent', {
      category,
      action,
      label,
      property,
      value,
    })
  }
}

function setCustomUrl(url) {
  if (window.ahana) {
    window.ahana('setCustomUrl', url)
  }
}

function trackPageView(title) {
  if (window.ahana) {
    window.ahana('trackPageView', title)
  }
}

function setUserId(user) {
  if (window.ahana) {
    window.ahana('setUserId', user.id)
  }
}

function addGlobalContexts(contextsArr) {
  if (window.ahana) {
    window.ahana('addGlobalContexts', contextsArr)
  }
}

function removeGlobalContexts(contextsArr) {
  if (window.ahana) {
    window.ahana('removeGlobalContexts', contextsArr)
  }
}

function clearGlobalContexts() {
  if (window.ahana) {
    window.ahana('clearGlobalContexts')
  }
}

export default {
  trackUnstructEvents,
  trackStructEvent,
  trackPageView,
  setCustomUrl,
  setUserId,
  addGlobalContexts,
  removeGlobalContexts,
  clearGlobalContexts,
}
